import type { OpenItem } from '@/api/hooks/useOpenItems';
import { OpenItemDetail } from './OpenItemDetail';

const GROUPS: Array<[OpenItem['status'], string]> = [
  ['answered', 'Answered'],
  ['sent', 'Sent'],
  ['draft', 'Draft'],
  ['reopened', 'Reopened'],
  ['resolved', 'Resolved'],
];

export function OpenItemGroups({ items, selectedIds, onToggle }: { items: OpenItem[]; selectedIds: string[]; onToggle: (item: OpenItem) => void }) {
  return (
    <div className="flex flex-col gap-4">
      {GROUPS.map(([status, label]) => {
        const group = items.filter((item) => item.status === status);
        if (group.length === 0) return null;
        return (
          <section key={status} aria-labelledby={`open-items-${status}`} className="rounded-[10px] border border-border bg-card">
            <h2 id={`open-items-${status}`} className="border-b border-border px-4 py-3 text-sm font-semibold">{label} · {group.length}</h2>
            <div>{group.map((item) => <OpenItemDetail key={item.open_item_id} item={item} selected={selectedIds.includes(item.open_item_id)} onToggle={() => onToggle(item)} />)}</div>
          </section>
        );
      })}
    </div>
  );
}

